/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ParkingEnum = 1 | 2 | 3 | 4 | 5;

export const ParkingEnum = {
    NUMBER_1: 1 as ParkingEnum,
    NUMBER_2: 2 as ParkingEnum,
    NUMBER_3: 3 as ParkingEnum,
    NUMBER_4: 4 as ParkingEnum,
    NUMBER_5: 5 as ParkingEnum
};

